import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const websiteApi = (token) => {
  const h = { headers: { Authorization: `Bearer ${token}` } };
  const base = `${API_URL}/admin/website`;
  return {
    registry: () => axios.get(`${base}/registry`, h).then((r) => r.data),
    pages: () => axios.get(`${base}/pages`, h).then((r) => r.data),
    health: () => axios.get(`${base}/health`, h).then((r) => r.data),
    linkCheck: () => axios.get(`${base}/link-check`, h).then((r) => r.data),
    healthScan: () => axios.post(`${base}/health/scan`, {}, h).then((r) => r.data),
    healthHistory: () => axios.get(`${base}/health/history`, h).then((r) => r.data),
    page: (slug) => axios.get(`${base}/pages/${slug}`, h).then((r) => r.data),
    createPage: (body) => axios.post(`${base}/pages`, body, h).then((r) => r.data),
    saveDraft: (slug, body) => axios.put(`${base}/pages/${slug}`, body, h).then((r) => r.data),
    publish: (slug) => axios.post(`${base}/pages/${slug}/publish`, {}, h).then((r) => r.data),
    unpublish: (slug) => axios.post(`${base}/pages/${slug}/unpublish`, {}, h).then((r) => r.data),
    discardDraft: (slug) => axios.post(`${base}/pages/${slug}/discard-draft`, {}, h).then((r) => r.data),
    duplicate: (slug, body) => axios.post(`${base}/pages/${slug}/duplicate`, body, h).then((r) => r.data),
    deletePage: (slug) => axios.delete(`${base}/pages/${slug}`, h).then((r) => r.data),
    importLegacy: (slug) => axios.post(`${base}/pages/${slug}/import-legacy`, {}, h).then((r) => r.data),
    preview: (slug) => axios.get(`${base}/pages/${slug}/preview`, h).then((r) => r.data),
    revisions: (slug) => axios.get(`${base}/pages/${slug}/revisions`, h).then((r) => r.data),
    restoreRevision: (slug, id) => axios.post(`${base}/pages/${slug}/revisions/${id}/restore`, {}, h).then((r) => r.data),
    newSection: (body) => axios.post(`${base}/sections/new`, body, h).then((r) => r.data),
    dataSource: (type, q) => axios.get(`${base}/data-sources/${type}`, { ...h, params: { q } }).then((r) => r.data),
    resolveSource: (source) => axios.post(`${base}/resolve-source`, source, h).then((r) => r.data),
    seoAudit: () => axios.get(`${base}/seo-audit`, h).then((r) => r.data),
    navigation: () => axios.get(`${base}/navigation`, h).then((r) => r.data),
    saveNavigation: (body) => axios.put(`${base}/navigation`, body, h).then((r) => r.data),
    design: () => axios.get(`${base}/design`, h).then((r) => r.data),
    saveDesign: (body) => axios.put(`${base}/design`, body, h).then((r) => r.data),
    globals: () => axios.get(`${base}/globals`, h).then((r) => r.data),
    saveGlobals: (body) => axios.put(`${base}/globals`, body, h).then((r) => r.data),
    redirects: () => axios.get(`${base}/redirects`, h).then((r) => r.data),
    createRedirect: (body) => axios.post(`${base}/redirects`, body, h).then((r) => r.data),
    updateRedirect: (id, body) => axios.put(`${base}/redirects/${id}`, body, h).then((r) => r.data),
    deleteRedirect: (id) => axios.delete(`${base}/redirects/${id}`, h).then((r) => r.data),
    media: (params) => axios.get(`${API_URL}/admin/cms/media`, { ...h, params }).then((r) => r.data),
    mediaList: (params) => axios.get(`${base}/media`, { ...h, params }).then((r) => r.data),
    mediaFolders: () => axios.get(`${base}/media/folders`, h).then((r) => r.data),
    createMediaFolder: (name) => axios.post(`${base}/media/folders`, { name }, h).then((r) => r.data),
    deleteMediaFolder: (name) => axios.delete(`${base}/media/folders/${encodeURIComponent(name)}`, h).then((r) => r.data),
    moveMedia: (id, folder) => axios.put(`${base}/media/${id}/folder`, { folder }, h).then((r) => r.data),
    updateMediaAlt: (id, alt_text) => axios.put(`${base}/media/${id}/alt`, { alt_text }, h).then((r) => r.data),
    uploadMedia: (formData) => axios.post(`${API_URL}/admin/cms/upload-media`, formData, { headers: { ...h.headers, 'Content-Type': 'multipart/form-data' } }).then((r) => r.data),
    siteSettings: () => axios.get(`${API_URL}/admin/site-settings`, h).then((r) => r.data),
    saveSiteSettings: (body) => axios.put(`${API_URL}/admin/site-settings`, body, h).then((r) => r.data),
    ai: (action, body) => axios.post(`${base}/ai/${action}`, body, h).then((r) => r.data),
    aiModels: () => axios.get(`${base}/ai/models`, h).then((r) => r.data),
    saveAiModels: (body) => axios.put(`${base}/ai/models`, body, h).then((r) => r.data),
    aiUsageMonthly: (month) => axios.get(`${base}/ai/usage/monthly`, { ...h, params: { month } }).then((r) => r.data),
    aiUsage: (params) => axios.get(`${base}/ai/usage`, { ...h, params }).then((r) => r.data),
  };
};

export const uid = (prefix = 'id') => `${prefix}-${Math.random().toString(36).slice(2, 10)}`;
